import idRestorationIcon from '../../assets/img/homepage-banner-id-restoration-icon.svg';
import walletProtectionIcon from '../../assets/img/homepage-banner-lost-wallet-icon.svg';
import monitoringIcon from '../../assets/img/homepage-banner-monitoring-icon.svg';
import {
  ROUTE_PATH_ACTIVATE,
  ROUTE_PATH_HOME,
  ROUTE_PATH_IDENTITY,
  ROUTE_PATH_PROTECTION,
  ROUTE_PATH_VIDEO,
  URL_IDENTITY_LOGIN_PAGE_EN_CA,
  URL_INTX_LOGIN_PAGE_EN_CA
} from '../../constants';
import { HomePageV3Translations } from '../types';

export const translations: HomePageV3Translations = {
  docTitle: 'Home',
  pageTitle: 'Detect and Respond to Threats Against your Identity',
  pageTempLoginTitle: 'Detect and Respond to Threats Against your Identity',
  pageText: 'OnGuard powered by ID Assist provides all of your identity protection services. While your online and credit monitoring services began from the time you enrolled in OnGuard, it is important that you set upset up your online account to access these services and maximize your protection.',
  pageSubtitle: [
    'Bank of Montreal is proud to offer their Performance, Premium, Platinum, Blue Rewards and Employee Plan',
    'customers access to OnGuard, at no extra charge.'
  ].join('\n'),
  pageLoginStateSubtitle: [
    'OnGuard powered by ID Assist provides all of your identity protection services.',
    ' While your online and credit monitoring services began from the time you enrolled',
    ' in OnGuard, it is important that you set up your online account to access these',
    ' services and maximize your protection.'
  ].join('\n'),
  watchVideo: {
    to: ROUTE_PATH_VIDEO,
    children: 'Learn More About OnGuard'
  },
  watchVideoModalTitle: 'Learn More About OnGuard',
  loginStateWatchVideo: {
    to: ROUTE_PATH_VIDEO,
    children: 'WATCH VIDEO'
  },
  loginStateWatchVideoModalTitle: 'Learn More About OnGuard',
  featureList: {
    lostWalletProtection: {
      icon: {
        src: walletProtectionIcon
      },
      title: 'Protection against the threats you&#39;re aware of&hellip;',
      summary: [
        '<h2 class="feature-title">Lost Wallet Protection</h2>',
        '<p class="feature-summary">One click or call to cancel your payment cards in the event of loss or theft</p>'
      ].join('\n'),
      action: {
        to: ROUTE_PATH_PROTECTION,
        children: 'I Lost My Wallet / Payment Cards'
      }
    },
    monitoring: {
      icon: {
        src: monitoringIcon
      },
      title: 'And the threats you aren&#39;t aware of&hellip;',
      summary: [
        '<h2 class="feature-title">Monitoring &amp; Alerts</h2>',
        '<p class="feature-summary">Add information to your online identity monitoring list and view your alerts</p>'
      ].join('\n'),
      action: {
        to: '',
        href: URL_INTX_LOGIN_PAGE_EN_CA,
        children: 'Already have an account?'
      }
    },
    loginSubmit: {
      icon: {},
      title: 'I already have an online account',
      summary: [
        'Great news! Log in now to access your identity protection services.',
      ].join('\n'),
      action: {
        to: '',
        href: URL_INTX_LOGIN_PAGE_EN_CA,
        children: 'LOGIN'
      }
    },
    setupAccount: {
      icon: {},
      title: 'I need to set up my online account',
      summary: [
        'No problem! Simply enter the email address you provided at the time you enrolled in',
        'OnGuard and we will send you an email to create your password and set-up your online account.'
      ].join('\n'),
      form:{
        emailAddress:{
          label:'Email Address',
          placeHolder:'Email Address',
          success:[
            'If we have the email @@emailAddress on file, we’ll send you a link to create',
            ' your password. Check your junk or spam mail if you don’t see it in your inbox.'
          ].join(''),
          error:{
            required: 'Please enter your Email Address.',
            valid:'Please enter a valid Email Address (ex. bobsmith@example.com).'
          }
        }
      },
      action: {
        to: '',
        children:'SUBMIT'
      }
    },
    idRestoration: {
      icon: {
        src: idRestorationIcon
      },
      title: 'And access to comprehensive recovery services',
      summary: ['<h2 class="feature-title">Identity Restoration</h2>', '<p class="feature-summary">The assistance you need to get back on your feet after threats against your identity</p>'].join('\n'),
      action: {
        to: ROUTE_PATH_IDENTITY,
        children: 'I Think My Identity Has Been Compromised'
      }
    }
  },
  nonMemberActions: {
    activate: {
      to: ROUTE_PATH_ACTIVATE,
      children: 'Activate'
    }
  },
  signInAction: {
    to: '',
    href: ROUTE_PATH_HOME,
    children: 'Already have an account?'
  },
  signUpAction: {
    to: '',
    href: `${ROUTE_PATH_ACTIVATE}?token=${process.env.REACT_APP_ACTIVATION_TOKEN}`,
    // prettier-ignore
    children: 'Don\'t have an account? Start here.'
  },
  maintenancePage:{
    OnGuard:{
      icon: {},
      title: '',
      summary: [
        'If you are an OnGuard  subscriber who signed up for services <span>before January 26, 2022</span>,',
        'you can continue to access your services here:'
      ].join('\n'),
      buttonName:'LOG IN',
      action: {
        to: '',
        href: URL_IDENTITY_LOGIN_PAGE_EN_CA,
        children: 'OK'
      }
    },
    idAssist:{
      icon: {},
      title: '',
      summary: [
        'If you are a new subscriber to OnGuard <span>since January 26, 2022</span>, access your services here:'
      ].join('\n'),
      buttonName:'LOG IN',
      action: {
        to: '',
        href: URL_INTX_LOGIN_PAGE_EN_CA,
        children: 'OK'
      }
    }
  },
  bannerTitle: '<span>Don&#39;t become a statistic!</span><br>',
  bannerText: '<span>Digital fraud in Canada is growing twice as fast as in the rest of the world. OnGuard provides the tools to help you protect your personal information and guard against the risk of identity fraud.</span><br>',
  bannerLink: '<span><u>Click here to learn more</u> &#x3009;</span>',
  srOnlyBannerText: [
    '<span>Don&#39;t become a statistic!</span><br>',
    '<span>Digital fraud in Canada is growing twice as fast as in the rest of the world.',
    ' OnGuard provides the tools to help you protect your personal information and guard against the risk of identity fraud.</span><br>',
    '<span><u>Click here to learn more</u></span>'
  ].join('\n')
};
